<template>
  <div>
    <headerSection></headerSection>
    <div class="x-main-content" :style="{ 'height':'100%','background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}" ><!--,'background-size':'900px 700px','background-image': `url(${require('../assets/images/Shiba-BG.jpg')})` -->
      <div id="main_content_recommend" class="container">
    <section class="row x-category-index" >
       <div class="col-sm-12 col-lg-12 col-12 recommend_section" style="padding-top:25px;">
            <fieldset class="form-group text-center mb-0 px-1">
                <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                    <div class="col-sm-12 col-lg-12 col-12" style="padding-top: 45px;">
                        <h3 class="text-center mb-3" style="font-weight: 500;color:#fff;">ประวัติธุรกรรม</h3>
                    </div>
                </div>
            </fieldset>
            <table class="tablecontainer">
              <thead>
                <tr>
                  <th><h1 style="text-align:center">วัน/เวลา</h1></th>
                  <th><h1 style="text-align:center">ประเภท</h1></th>
                  <th><h1 style="text-align:center">จำนวน</h1></th>
                  <th><h1 style="text-align:center">สถานะ</h1></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in history" :key="index">
                  <td style="text-align:center;color:#fff;">{{item.createdateShow}}</td>
                  <td style="text-align:center">&nbsp;&nbsp;<font color="#77C3F4" v-if="item.type=='วงล้อ' || item.type=='รูเล็ต' || item.type=='ฝากต่อเนื่อง' || item.type=='พันธมิตร' || item.type=='คืนยอดเล่น'">{{ item.type }}</font><font color="#f92c6a" v-else-if="item.type=='ถอน'">{{ item.type }}</font><font color="#3B9854" v-else>{{ item.type }}</font></td>
                  <td style="text-align:right;color:#fff;">{{ numberWithCommas(item.qty) }}</td>
                  <td style="text-align:center"><font color="#3B9854" v-if="item.status=='ดำเนินการแล้ว'">✅</font><font color="#f92c6a" v-else-if="item.status=='ยกเลิก'">❌</font><font color="#f92c6a" v-else>⏳</font></td>
                </tr>
              </tbody>
            </table>
        </div>

    </section>
</div>
</div>
<footerSection></footerSection>
</div>
</template>

<script>
// color: #FB667A;
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
import _ from 'lodash'
export default {
  name: 'Promotion',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  computed: {
	  user () {
      return this.$store.state.user.user
    }
  },
  data () {
    return {
      history: []
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    }
  },
  async mounted () {
    this.scrollToTop()
    this.$store.commit('user/SET_LOADING', true)
    const user = this.getUserId()
    const history = []
    let lastdate = ''
    await firebase.firestore().collection('history').where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(500).get().then((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().qty) {
          const data = doc.data()
          data.key = doc.id
          data.createdateShow = moment(data.createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:mm')
          lastdate = data.createdate
          history.push(data)
        }
      })
    })
    await firebase.firestore().collection('spin').where('userkey', '==', user.key).where('createdate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        let game = 'วงล้อ'
        if (doc.data().game === '3boxs') {
          game = 'เปิดหีบสมบัติ'
        } else if (doc.data().game === 'roulet') {
          game = 'รูเล็ต'
        } else if (doc.data().game === 'checkin') {
          game = 'check-in'
        } else if (doc.data().game === 'code') {
          game = 'code'
        } else if (doc.data().game === 'scratch') {
          game = 'ขูดๆถูๆ'
        } else if (doc.data().game === 'gift') {
          game = 'เปิดกล่องของขวัญ'
        }

        history.push({
          key: doc.id,
          type: game,
          createdate: doc.data().createdate,
          createdateShow: moment(doc.data().createdate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:ss'),
          qty: doc.data().value,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'ฝากต่อเนื่อง',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:ss'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('partner_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'พันธมิตร',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:ss'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })
    await firebase.firestore().collection('cashback_all').where('userkey', '==', user.key).where('status', '==', true).where('receivedate', '>=', lastdate).get().then((result) => {
      result.forEach((doc) => {
        history.push({
          key: doc.id,
          type: 'คืนยอดเล่น',
          createdate: doc.data().receivedate,
          createdateShow: moment(doc.data().receivedate, 'YYYY-MM-DD HH:mm:ss').format('DD MMM,YY HH:ss'),
          qty: doc.data().total,
          status: 'ดำเนินการแล้ว'
        })
      })
    })

    this.history = _.orderBy(history, ['createdate'], ['desc'])
    this.$store.commit('user/SET_LOADING', false)
  }
}
</script>
<style scoped>
/* ============ PREMIUM GOLD THEME - HISTORY ============ */

/* ============ MAIN CONTENT AREA ============ */
.x-main-content {
    background: linear-gradient(180deg, rgba(13, 13, 13, 0.95) 0%, rgba(26, 26, 46, 0.9) 100%) !important;
    min-height: 100vh;
}

/* ============ SECTION CONTAINER ============ */
.recommend_section {
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(251, 200, 68, 0.2);
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* ============ TITLE STYLING ============ */
h3.text-center {
    background: linear-gradient(135deg, #fbc844 0%, #FFD700 50%, #f88012 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    letter-spacing: 1px;
}

/* ============ PREMIUM TABLE ============ */
.tablecontainer {
    text-align: left;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    display: table;
    padding: 0 0 2em 0;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.tablecontainer th {
    background: linear-gradient(135deg, #fbc844 0%, #f88012 100%);
    padding: 15px 10px;
}

.tablecontainer th h1 {
    font-family: 'Kanit', sans-serif;
    font-weight: 600;
    font-size: 0.9em;
    text-align: center;
    color: #0d0d0d;
    margin: 0;
}

.tablecontainer td {
    font-family: 'Kanit', sans-serif;
    font-weight: normal;
    font-size: 0.9em;
    padding: 12px 8px;
    border-bottom: 1px solid rgba(251, 200, 68, 0.1);
    transition: all 0.3s ease;
}

.tablecontainer td, .tablecontainer th {
    padding-bottom: 12px;
    padding-top: 12px;
    padding-left: 8px;
    padding-right: 8px;
}

/* Background-color of the odd rows */
.tablecontainer tr:nth-child(odd) {
    background: rgba(50, 60, 80, 0.5);
}

/* Background-color of the even rows */
.tablecontainer tr:nth-child(even) {
    background: rgba(44, 52, 70, 0.5);
}

.tablecontainer tbody tr {
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

.tablecontainer tr:hover {
    background: rgba(251, 200, 68, 0.1);
}

.tablecontainer td:hover {
    background: rgba(251, 200, 68, 0.2);
    color: #fbc844;
    transition: all 0.2s ease;
}

/* ============ STATUS COLORS ============ */
.tablecontainer td font[color="#3B9854"] {
    text-shadow: 0 0 8px rgba(59, 152, 84, 0.5);
}

.tablecontainer td font[color="#77C3F4"] {
    text-shadow: 0 0 8px rgba(119, 195, 244, 0.5);
}

.tablecontainer td font[color="#f92c6a"] {
    text-shadow: 0 0 8px rgba(249, 44, 106, 0.5);
}

/* ============ RESPONSIVE ============ */
@media (max-width: 500px) {
    .x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-img-category {
        width: 45px;
        height: 45px;
    }
    .tablecontainer th h1 {
        font-size: 0.75em;
    }
    .tablecontainer td {
        font-size: 0.8em;
        padding: 8px 4px;
    }
}

@media (max-width: 991.98px) {
    .x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-menu-text .-menu-text-main {
        font-size: .8rem;
        font-weight: bold;
        font-family: 'Kanit';
        text-align: center;
        display: block;
        padding-top: 4px;
    }
}

@media (min-width: 991.98px) {
    .x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-menu-text .-menu-text-main {
        font-size: 16px;
        font-weight: bold;
        font-family: 'Kanit';
        text-align: center;
        display: block;
        padding-top: 4px;
    }
    .x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent {
        display: flex;
    }
}

@media (max-width: 990px) {
    #main_content_recommend .x-category-index,
    #main_content_income .x-category-index {
        padding-top: 10px;
    }
}
</style>
